import { Create, SimpleForm, TextInput, SelectInput, BooleanInput } from 'react-admin';

const DATA_TYPE_CHOICES = [
  { id: 'select', name: 'select — רשימת אפשרויות' },
  { id: 'text',   name: 'text — טקסט חופשי' },
];

const AttributeCreate = () => (
  <Create title="תכונה חדשה (גלובלית)">
    <SimpleForm>
      <TextInput source="label"     label="תווית (label)"  fullWidth />
      <TextInput source="key" label="מפתח (key)" fullWidth inputProps={{ dir: 'ltr' }}
        helperText="אופציונלי — אם ריק ייווצר אוטומטית מהתווית. מומלץ: אותיות אנגליות וקווים תחתיים בלבד" />
      <SelectInput source="data_type" label="סוג נתון" choices={DATA_TYPE_CHOICES} defaultValue="select" fullWidth />
      <BooleanInput source="required" label="שדה חובה" />
      <TextInput
        source="options"
        label='אפשרויות (מופרדות בפסיק, למשל: basic,higher,higher_higher)'
        helperText="ממלאים רק אם סוג הנתון הוא select"
        fullWidth
        inputProps={{ dir: 'ltr' }}
      />
    </SimpleForm>
  </Create>
);

export default AttributeCreate;
